@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/common" as c;

.closeButton {
  position: absolute;
  top: 24px;
  right: 24px;
  cursor: pointer;

  @include c.containerMedia(v.$js-defined-mobile-breakpoint) {
    top: 16px;
    right: 16px;
  }
}

.modal {
  padding: 48px;
  width: 656px;

  @include c.containerMedia(780px) {
    padding: 24px;
    width: calc(100% - 30px);
  }
}

.content {
  padding: 24px;
}

.title {
  text-align: center;
  @include t.text(20px, 30px, 600);
  color: v.$palette-gray-900;
}

.link {
  @include t.text(16px, 26px, 600);
  width: 240px;
  padding: 8px 24px;
  background-color: v.$palette-blue;
  text-decoration: none;
  box-shadow: v.$shadow-1;
  &, &:hover, &:active, &:focus {
    color: v.$palette-pure-white;
  }
  &[disabled] {
    box-shadow: none;
  }
}

.separator {
  width: 100%;
  height: 2px;
  border-radius: 100px;
  background: v.$palette-gray-100;
  margin: 16px 0;
}

.totalValue {
  @include t.text(20px, 30px, 600);
  color: v.$palette-gray-900;
  text-align: right;
  margin-bottom: 16px;
}
